import useDutchiePayEnrollment from 'hooks/use-dutchiePay-enrollment';
import { useApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import useErnie from 'shared/hooks/use-ernie';
import { ERNIE_DEFAULT_MESSAGES, ERNIE_TIMEOUTS, ERNIE_TYPES } from 'shared/constants';
import { getLogger } from 'src/utils/datadog-logger';
import { LOG_NAMESPACES } from 'src/payments/constants';

const logger = getLogger(LOG_NAMESPACES.PBB);

export const userExistsCheck = gql`
  query UserExistsCheck($input: userIdExistsInput!) {
    userExistsCheck(input: $input) {
      exists
      _id
    }
  }
`;

type UseUserExistsResult = {
  userExistsCheckQuery: ({ email }: { email: string }) => Promise<void>;
};

export const useUserExistsCheck = (): UseUserExistsResult => {
  const apolloClient = useApolloClient();
  const DutchiePayEnrollment = useDutchiePayEnrollment();
  const showErnie = useErnie();

  const userExistsCheckQuery = async ({ email }): Promise<void> => {
    try {
      const result = await apolloClient.query({
        query: userExistsCheck,
        variables: { input: { email } },
      });

      const { exists } = result.data.userExistsCheck;

      DutchiePayEnrollment.setExistingUser(exists);
      DutchiePayEnrollment.emailStepCompleted(email);
    } catch (err) {
      logger.error('User existence check failed', {
        error: err?.message ?? 'Unknown error',
        errorCode: err?.code ?? 'NO_CODE',
        step: 'emailForm',
      });
      console.error(err);
      showErnie(ERNIE_DEFAULT_MESSAGES.ERROR, ERNIE_TYPES.DANGER, ERNIE_TIMEOUTS.LONG);
    }
  };

  return {
    userExistsCheckQuery,
  };
};
